<template> 
  <div class="max-w-md mx-auto mt-8 bg-white p-6 rounded-xl shadow-md">
    <h2 class="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
      {{ isEdit ? "Edit Criterion" : "Create Criterion" }}
      <BaseInfoIcon :text="ERKLAERUNG.kriteriumFormular" :label="isEdit ? 'Edit Criterion' : 'Create Criterion'" />
    </h2>

    <form @submit.prevent="submitForm" class="space-y-4">
      <!-- Criterion Name -->
      <BaseInput
        v-model="criterion.name"
        placeholder="Criterion Name"
        required
      />

      <!-- Criterion Type (disabled if editing) -->
      <BaseSelect
        v-model="criterion.type"
        :options="typeOptions"
        placeholder="Select Type"
        :showPlaceholder="true"
        :disabled="isEdit"
        required
      />

      <!-- Criterion Description -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Description (Optional)</label>
        <textarea
          v-model="criterion.description"
          placeholder="Enter a description for this criterion..."
          rows="3"
          class="w-full border border-gray-300 rounded-lg p-2 focus:ring-indigo-500 focus:border-indigo-500"
        ></textarea>
      </div>

      <!-- Buttons -->
      <div class="flex justify-between pt-4">
        <!-- Cancel button on the left -->
        <BaseButton
          type="button"
          variant="cancel"
          @click="$router.push('/criterias')"
        >
          Cancel
        </BaseButton>

        <!-- Submit button on the right -->
        <BaseButton type="submit">
          {{ isEdit ? "Save" : "Create" }}
        </BaseButton>
      </div>
    </form>
  </div>
</template>

<script>
import BaseInput from "@/BaseComponents/BaseInput.vue";
import BaseButton from "@/BaseComponents/BaseButton.vue";
import BaseInfoIcon from "@/BaseComponents/BaseInfoIcon.vue";
import BaseSelect from "@/BaseComponents/BaseSelect.vue";
import { ERKLAERUNG } from "@/async-sessions/erklaerungen";
import { createCriterion, updateCriterion, getCriterion } from "@/api/criterias";

export default {
  components: { BaseInput, BaseButton, BaseInfoIcon, BaseSelect },
  data() {
    return {
      ERKLAERUNG,
      criterion: { name: "", type: "", description: "" },
      typeOptions: [
        { label: "Boolean", value: "boolean" },
        { label: "Countable", value: "countable" },
        { label: "Text", value: "text" },
      ],
      isEdit: false,
    };
  },
  async mounted() {
    const criterionId = this.$route.params.id;
    if (criterionId) {
      this.isEdit = true;
      try {
        const res = await getCriterion(criterionId);
        this.criterion = { ...res.data };
      } catch (err) {
        alert(err.response?.data?.detail || "Failed to load criterion");
        this.$router.push("/criterias");
      }
    }
  },
  methods: {
    async submitForm() {
      try {
        if (this.isEdit) {
          await updateCriterion(this.$route.params.id, { 
            name: this.criterion.name,
            description: this.criterion.description
          });
        } else {
          await createCriterion(this.criterion);
        }
        this.$router.push("/criterias");
      } catch (err) {
        alert(err.response?.data?.detail || "Failed to save criterion");
      }
    },
  },
};
</script>
